<template>
  <span>
    <div
      v-if="error"
      class="card min-height-card u-font-size-5 u-display-flex u-flex-align-items-center u-flex-justify-content-center"
    >
      Something went wrong. Please try again later.
    </div>
    <div
      v-else
      class="card min-height-card u-flex-direction-column u-width-100 u-display-flex adgroupProfile"
    >
      <div v-if="openVideoProfilePanel">
        <svAdGroupVideoProfileSelect
          :ad-group-id="entityId"
          :campaign-id="parentEntityId"
          :current-media-id="mediaId"
          :current-ad-group-media-id="adGroupMediaId"
          @closePanelMethod="closeVideoProfilePanel"
        />
      </div>
      <tableWrapper
        :table-data-component-key="tableDataComponentKey"
        :date-filter="dateFilter"
        :tab-metadata="tabMetadata"
        :widget="widget"
        :header-options="headerOptions"
        :context="context"
        :entity-config="entityConfig"
      />
    </div>
  </span>
</template>

<script>
import TableWrapper from '@/pages/entity_details/common_components/tableWrapper.vue';
import svAdGroupVideoProfileSelect from '@/pages/entity_details/widget_templates/SV/svAdGroupVideoProfileSelect.vue';
import Vue from 'vue';
import HttpService from '@/utils/services/http-service';
import tableSwitchComponent from '@/pages/dashboard_service_campaign_management/common_components/tableSwitchComponent.vue';
import SvAdGroupVideoProfilePauseCampaignModal from '@/pages/entity_details/configs/walmart/widget_templates/SvAdGroupVideoProfilePauseCampaignModal.vue';

const preview = {
  props: {
    imgUrl: {
      type: String,
      default: ''
    },
    altText: {
      type: String,
      default: 'Brand Logo'
    },
    width: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: ''
    }
  },
  template: `
   <img :src="imgUrl" :alt="altText" :style="{'width':width || '300px', 'height':height || '180px'}" />
  `
};

const videoPreview = {
  props: {
    videoUrl: {
      type: String,
      default: ''
    }
  },
  template: `
    <span>
        <video
            :src="videoUrl"
            controls
            disablepictureinpicture
            controlsList="nodownload noplaybackrate"
            class="u-width-100 u-height-100"
            style="object-fit: cover"
        >
      <source
          :src="videoUrl"
          type="video/mp4"
      />
    </video>
    </span>
  `
};

export default {
  components: { SvAdGroupVideoProfilePauseCampaignModal, TableWrapper },
  props: {
    dateFilter: {
      default: () => {},
      type: Object
    },
    tabMetadata: {
      default: () => {},
      type: Object
    },
    entityConfig: {
      default: () => {},
      type: Object
    },
    entityId: {
      default: null,
      type: String
    },
    parentEntityId: {
      default: null,
      type: String
    },
    parentEntityData: {
      default: null,
      type: Object
    }
  },
  data() {
    const context = this;
    return {
      context,
      error: false,
      loadingAdGroupMediaDetails: true,
      openVideoProfilePanel: false
    };
  },
  computed: {
    tableDataComponentKey() {
      return this.$store.getters[
        this.tabConfig?.apiConfigs?.getTableDataComponentKeyGetter
      ];
    },
    headerOptions() {
      const obj = {};
      if (this.tabMetadata?.widgets[0]) {
        const isReviewDataVisible =
          this?.tabConfig?.headerOptions?.(this).length > 0;
        const displayType = isReviewDataVisible ? 'flex' : 'grid';
        obj[this.tabMetadata.widgets[0]] = {
          props: {
            headerOptions: [...(this?.tabConfig?.headerOptions?.(this) || [])],
            enableManageColumns: false,
            enableDownload: false,
            headerContainerGridStyles: {
              'grid-template-columns': '1fr auto auto',
              display: displayType
            },
            searchParams: {
              show: false
            },
            rowHeight: 300,
            gridOptions: {
              context: { componentParent: this },
              domLayout: 'normal',
              onRowDataChanged: () => {}
            }
          }
        };
      }
      return obj;
    },
    campaignInfo() {
      return this.$store.getters[this.tabConfig?.apiConfigs?.getter];
    }
  },
  created() {
    this.tabConfig = this.entityConfig.tabs[this?.tabMetadata?.component];
    this.getAdGroupMediaId();
    this.widget = {
      ':widget': this.tabMetadata.widgets[0],
      ':orderByList': [],
      ':dimensionNameValueList': [],
      keepExistingDimensionNameValueList: true,
      replaceEntityInDimensionNameValueList: {
        ':adgroup_id': this.entityId
      },
      replaceEntityInOperationsObject: {
        ':system': `campaign_${this.parentEntityId}`
      }
    };
    Vue.component('preview', preview);
    Vue.component('videoPreview', videoPreview);
    Vue.component('tableSwitchComponent', tableSwitchComponent);
    Vue.component('svAdGroupVideoProfileSelect', svAdGroupVideoProfileSelect);
  },
  methods: {
    async getAdGroupMediaId() {
      this.error = false;
      try {
        const response = await HttpService.post('FETCH_AMS_ACTIONS_MANAGER', {
          retailer: this.$store.getters.getRetailer,
          advertiserId: this.$route?.query?.advertiser_id,
          campaignId: this.parentEntityId,
          adGroupId: this.entityId,
          filterName: null,
          filterDate: null,
          type: 'ADGROUP_MEDIA'
        });
        this.adGroupMediaId = response.data.response[0]?.adGroupMediaId;
        this.mediaId = response.data.response[0]?.mediaId;
      } catch (e) {
        this.error = true;
      }
    },
    replaceVideo() {
      this.openVideoProfilePanel = true;
    },
    closeVideoProfilePanel() {
      this.openVideoProfilePanel = false;
    }
  }
};
</script>

<style lang="css" scoped>
.min-height-card {
  min-height: 630px;
}
</style>

<style lang="css">
.campaign_details_table_header_padding .header-container-cwc {
  padding: 0;
}
.adgroupProfile div[col-id^='walmart_cm_profile_status'].ag-cell {
  margin: 0;
  padding: 0;
}
</style>
